<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" :inline="true" class="demo-form-inline"
          style="padding-top:0;margin-top:0">
          <el-form-item label="项目名称：">
            <el-input size="medium" v-model="searchForm.PROJECT_NAME" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="matchProject(checkedArray)">批量匹配</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="项目名称" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="所属团餐公司" prop="TC_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="matchProject([scope.row.PROJECT_ID])" type="text">匹配</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      checkedArray: [],
      id: this.$route.params.id,
    };
  },
  created() { },
  methods: {
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 22,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_NAME) {
        params.PROJECT_NAME = this.searchForm.PROJECT_NAME;
      }
      http.post(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    matchProject(arr) {
      const params = {
        SERVICE_ID: '10049',
        OTYPE: 19,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        GROUP_ID: Number(this.id),
        MATCH_LIST: arr,
      };
      http.post(params).then((result) => {
        if (result) {
          this.$message.show({ text: '匹配成功', type: 'success' });
          this.queryTable();
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => item.PROJECT_ID);
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/sortingGroupMatchProjrct.vue